import React, { useState, useEffect } from "react";
import "./resuableHeader.css";
import CompanyLogo from "../Images/Frames.png";
import LogoutIcon from "../Images/logout-icon.png";
import defaultProfile from "../Images/profile-user.png";
import BellIcon from "../Images/bell_.png";
import CheckIcon from "../Images/arrow_down.svg";

const ReusableHeader = ({ setIsAuthenticated = () => {}, userDetails }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Derive user data from props instead of API call
  const userData = {
    name: userDetails?.first_name || "User",
    designation: userDetails?.user_type || "Employee",
    profilePicture: userDetails?.image || defaultProfile,
  };

  // Check if user details are still loading
  const isLoading = !userDetails;

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const handleClickOutside = (event) => {
    const dropdown = document.querySelector(".profile-container");
    if (dropdown && !dropdown.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logout = () => {
    localStorage.removeItem("accessToken");
    setIsAuthenticated(false);
    window.location.href = "/login-page";
  };

  return (
    <header className="header-container">
      <div className="header-logo-container">
        <img src={CompanyLogo} alt="Quanta People Lense" />
      </div>

      <div className="header-right-section">
        {/* <div className="notification-container">
          <div className="bell-icon-wrapper">
            <img src={BellIcon} alt="Notifications" className="bell-icon" />
          </div>
        </div> */}

        <div className="profile-container">
          <div
            className={`profile-wrapper ${isDropdownOpen ? "dropdown-open" : ""} ${
              isHovered && !isDropdownOpen ? "hovered" : ""
            }`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="profile-button" onClick={toggleDropdown}>
              <div className="check-icon-wrapper">
                <img src={CheckIcon} alt="Check" className="check-icon" />
              </div>

              <div className="profile-details">
                <div className="profile-text">
                  <p className="profile-name">{isLoading ? "Loading..." : userData.name}</p>
                  <p className="profile-designation">{isLoading ? "" : userData.designation}</p>
                </div>

                <div className="profile-image-wrapper">
                  <img
                    src={userData.profilePicture}
                    alt="Profile"
                    className="profile-image"
                    onError={(e) => {
                      e.target.src = defaultProfile;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Always render the dropdown but control visibility with CSS */}
            <div className="logout-section">
              <button className="logout-button" onClick={logout}>
                <img src={LogoutIcon} alt="Logout" className="logout-icon" />
                <span>LOGOUT</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default ReusableHeader;